import { AfterViewInit, Component, OnDestroy, OnInit, Renderer2 } from '@angular/core'
import { NavigationEnd, Router, RouterOutlet } from '@angular/router'
import { filter } from 'rxjs'
import { ScriptLoaderService } from '../../services/script-loader.service'

@Component({
  selector: 'app-website-layout',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './website-layout.component.html',
  // template: `<router-outlet />`,
  styleUrls: ['./website-layout.component.scss']
})
export class WebsiteLayoutComponent implements OnInit, OnDestroy, AfterViewInit {
  private styleIds = [
    'layout-bootstrap',
    'layout-tabler-icons',
    'layout-fontawesome-plugin',
    'layout-fontawesome-all',
    'layout-aos',
    'layout-animate',
    'layout-main',
    'layout-owl'
  ]

  private scriptIds = [
    'bootstrap-bundle',
    'wow',
    'meanmenu',
    'owl',
    'aos',
    'swiper',
    'swiper-owl',
    'counterup',
    'waypoints',
    'cursor',
    'script',
    'inquiry'
  ]

  currentYear!: number
  previousYear!: number

  constructor(
    private renderer: Renderer2,
    router: Router,
    private scriptLoader: ScriptLoaderService
  ) {
    // console.log('Website Layout constructor')

    this.currentYear = new Date().getFullYear()
    this.previousYear = this.currentYear - 1

    // router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(() => {
    //   console.log('Final URL:', router.url)
    // })
  }
  // ngOnInit(): void {
  //   // console.log('Website Layout init')
  //   this.loadStyle('layout-bootstrap', 'assets/layout/assets/css/bootstrap.min.css')
  //   this.loadStyle(
  //     'layout-tabler-icons',
  //     'assets/layout/assets/plugins/tabler-icons/tabler-icons.css'
  //   )
  //   this.loadStyle(
  //     'layout-fontawesome-plugin',
  //     'assets/layout/assets/plugins/fontawesome/css/fontawesome.min.css'
  //   )
  //   this.loadStyle(
  //     'layout-fontawesome-all',
  //     'assets/layout/assets/plugins/fontawesome/css/all.min.css'
  //   )
  //   this.loadStyle('layout-aos', 'assets/layout/assets/plugins/aos/aos.css')
  //   this.loadStyle('layout-animate', 'assets/layout/assets/css/animate.css')
  //   this.loadStyle('layout-main', 'assets/layout/assets/css/style.css')
  //   this.loadStyle('layout-owl', 'assets/layout/assets/plugins/owlcarousel/owl.carousel.min.css')

  //   // this.loadScript('jquery', 'assets/layout/assets/js/jquery.min.js')
  //   this.loadScript('bootstrap-bundle', 'assets/layout/assets/js/bootstrap.bundle.min.js')
  //   this.loadScript('wow', 'assets/layout/assets/js/wow.min.js')
  //   this.loadScript('meanmenu', 'assets/layout/assets/js/jquery.meanmenu.min.js')
  //   this.loadScript('owl', 'assets/layout/assets/plugins/owlcarousel/owl.carousel.min.js')
  //   this.loadScript('aos', 'assets/layout/assets/plugins/aos/aos.js')
  //   this.loadScript('swiper', 'assets/layout/assets/plugins/swiper/swiper-bundle.min.js')
  //   this.loadScript('swiper-owl', 'assets/layout/assets/plugins/owlcarousel/owl.carousel.min.js')
  //   this.loadScript('waypoints', 'assets/layout/assets/js/jquery.waypoints.min.js')
  //   this.loadScript('counterup', 'assets/layout/assets/js/jquery.counterup.min.js')
  //   this.loadScript('cursor', 'assets/layout/assets/js/cursor.js')
  //   this.loadScript('script', 'assets/layout/assets/js/script.js')
  //   this.loadScript('inquiry', 'assets/layout/assets/js/inquiry.js')
  // }

  ngOnInit(): void {
    // this.scriptLoader.loadStyles([
    //   'assets/plugins/select2/css/select2.min.css',
    //   'assets/plugins/flatpickr/flatpickr.min.css',
    //   'assets/layout/assets/plugins/aos/aos.css'
    // ])

    document.body.classList.add('website-theme')

    this.scriptLoader.loadStyles([
      'assets/layout/assets/css/bootstrap.min.css',
      'assets/layout/assets/plugins/tabler-icons/tabler-icons.css',
      'assets/layout/assets/plugins/fontawesome/css/fontawesome.min.css',
      'assets/layout/assets/plugins/fontawesome/css/all.min.css',
      // 'assets/layout/assets/plugins/aos/aos.css',
      // 'assets/layout/assets/css/animate.css',
      'assets/layout/assets/plugins/owlcarousel/owl.carousel.min.css'
      // 'assets/plugins/select2/css/select2.min.css',
      // 'assets/plugins/flatpickr/flatpickr.min.css'
    ])

    this.scriptLoader
      .loadScripts([
        'assets/layout/assets/plugins/aos/aos.js',
        'assets/js/feather.min.js',
        'assets/js/jquery.slimscroll.min.js',
        'assets/layout/assets/js/bootstrap.bundle.min.js',
        'assets/layout/assets/js/wow.min.js',
        'assets/layout/assets/js/jquery.meanmenu.min.js',
        'assets/layout/assets/plugins/owlcarousel/owl.carousel.min.js',
        'assets/layout/assets/plugins/swiper/swiper-bundle.min.js',
        'assets/layout/assets/js/jquery.waypoints.min.js',
        'assets/layout/assets/js/jquery.counterup.min.js',
        'assets/layout/assets/js/cursor.js',
        'assets/layout/assets/js/script.js',
        'assets/layout/assets/js/inquiry.js',
        'assets/plugins/select2/js/select2.min.js'
      ])
      .then(() => {
        ;(window as any).AOS?.init()
        if ((window as any).WOW) {
          new (window as any).WOW().init()
        }
        if ((window as any).feather) {
          ;(window as any).feather.replace()
        }

        if (document.readyState === 'complete') {
          ;(window as any).AOS?.refreshHard()
        } else {
          window.addEventListener(
            'load',
            () => {
              ;(window as any).AOS?.refreshHard()
            },
            { once: true }
          )
        }
        // document.getElementById('pre-hydration-loader')?.remove()
      })
  }

  // ngAfterViewInit(): void {
  //   this.scriptLoader
  //     .loadScripts([
  //       'assets/js/feather.min.js',
  //       'assets/js/jquery.slimscroll.min.js',
  //       'assets/layout/assets/plugins/swiper/swiper-bundle.min.js',
  //       'assets/layout/assets/plugins/owlcarousel/owl.carousel.min.js',
  //       'assets/layout/assets/js/wow.min.js',
  //       'assets/layout/assets/plugins/aos/aos.js',
  //       'assets/layout/assets/js/cursor.js',
  //       'assets/layout/assets/js/script.js',
  //       'assets/plugins/select2/js/select2.min.js'
  //     ])
  //     .then(() => {
  //       // WOW.init(), AOS.init() jaisi calls yahan jo window pe expose hoti hain
  //       ;(window as any).AOS?.init()
  //       // new (window as any).WOW()
  //       //   .init()(window as any)
  //       //   .feather?.replace()
  //       document.getElementById('pre-hydration-loader')?.remove()
  //       // if ((window as any).feather) {
  //       //   ;(window as any).feather.replace()
  //       // } else {
  //       //   console.warn('feather.js load nahi hua ya global expose nahi hua')
  //       // }
  //     })
  // }

  ngAfterViewInit(): void {
    this.scriptLoader
      .loadScripts([
        'assets/js/feather.min.js',
        'assets/js/jquery.slimscroll.min.js',
        'assets/layout/assets/js/bootstrap.bundle.min.js',
        'assets/layout/assets/js/wow.min.js',
        'assets/layout/assets/js/jquery.meanmenu.min.js',
        'assets/layout/assets/plugins/owlcarousel/owl.carousel.min.js',
        'assets/layout/assets/plugins/aos/aos.js',
        'assets/layout/assets/plugins/swiper/swiper-bundle.min.js',
        'assets/layout/assets/js/jquery.waypoints.min.js',
        'assets/layout/assets/js/jquery.counterup.min.js',
        'assets/layout/assets/js/cursor.js',
        'assets/layout/assets/js/script.js',
        'assets/layout/assets/js/inquiry.js',
        'assets/plugins/select2/js/select2.min.js'
      ])
      .then(() => {
        ;(window as any).AOS?.init()
        if ((window as any).WOW) {
          new (window as any).WOW().init()
        }
        if ((window as any).feather) {
          ;(window as any).feather.replace()
        }
        document.getElementById('pre-hydration-loader')?.remove()
      })
    this.loadTawk()
  }

  ngOnDestroy(): void {
    document.body.classList.remove('website-theme')
  }

  loadStyle(id: string, href: string) {
    if (!document.getElementById(id)) {
      const link = this.renderer.createElement('link')
      link.id = id
      link.rel = 'stylesheet'
      link.href = href
      this.renderer.appendChild(document.head, link)
    }
  }

  loadScript(id: string, src: string) {
    if (!document.getElementById(id)) {
      const script = this.renderer.createElement('script')
      script.id = id
      script.src = src
      script.async = true
      this.renderer.appendChild(document.body, script)
    }
  }

  // ngOnDestroy(): void {
  //   console.log('Website Layout destroing')
  //   ;[...this.styleIds, ...this.scriptIds].forEach(id => {
  //     const el = document.getElementById(id)
  //     if (el) {
  //       el.remove()
  //     }
  //   })

  //   console.log('Website Layout destroyed')
  // }

  loadTawk() {
    if (document.getElementById('tawk-script')) {
      return
    }

    // Tawk API initialize before loading script
    ;(window as any).Tawk_API = (window as any).Tawk_API || {}
    ;(window as any).Tawk_LoadStart = new Date()

    ;(window as any).Tawk_API.onLoad = function () {
      // Keep widget closed by default
      ;(window as any).Tawk_API.close()
      ;(window as any).Tawk_API.minimize()
    }

    const script = document.createElement('script')
    script.id = 'tawk-script'
    script.async = true
    script.src = 'https://embed.tawk.to/6a465d63b539ed1d4853cbfe/1jshdpjin'
    script.charset = 'UTF-8'
    script.setAttribute('crossorigin', '*')

    document.body.appendChild(script)
  }
}
